function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1667 8.22396C16.1667 12.274 12.8834 15.5573 8.83333 15.5573C4.78325 15.5573 1.5 12.274 1.5 8.22396C1.5 4.17387 4.78325 0.890625 8.83333 0.890625C12.8834 0.890625 16.1667 4.17387 16.1667 8.22396Z",
  fill: "#4290F3",
  fillOpacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4167 8.22396C15.4167 11.8598 12.4692 14.8073 8.83333 14.8073V16.3073C13.2976 16.3073 16.9167 12.6883 16.9167 8.22396H15.4167ZM8.83333 14.8073C5.19746 14.8073 2.25 11.8598 2.25 8.22396H0.75C0.75 12.6883 4.36903 16.3073 8.83333 16.3073V14.8073ZM2.25 8.22396C2.25 4.58808 5.19746 1.64062 8.83333 1.64062V0.140625C4.36903 0.140625 0.75 3.75966 0.75 8.22396H2.25ZM8.83333 1.64062C12.4692 1.64062 15.4167 4.58808 15.4167 8.22396H16.9167C16.9167 3.75966 13.2976 0.140625 8.83333 0.140625V1.64062Z",
  fill: "#4290F3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33398 5.94681C6.33398 5.17899 7.16347 4.69762 7.83012 5.07857L11.8146 7.35539C12.4864 7.73928 12.4864 8.70798 11.8146 9.09188L7.83012 11.3687C7.16347 11.7496 6.33398 11.2683 6.33398 10.5005V5.94681Z",
  fill: "#4290F3"
});

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6607b169.svg";
export { ForwardRef as ReactComponent };